import { Head } from '@inertiajs/react'
import WorkerPortalShell from '@/frontend/layouts/worker-first/WorkerPortalShell'
import { ProcessDetailHeader } from '@/frontend/features/ProcessDetail/ProcessDetailHeader'
import { ExecutionsPanel } from '@/frontend/features/ProcessDetail/ExecutionsPanel'
import { RoutinesSidePanel } from '@/frontend/features/ProcessDetail/RoutinesSidePanel'
import { UpcomingRunsSidePanel, MemorySidePanel } from '@/frontend/features/ProcessDetail/ProcessSidePanels'
import type { DigitalWorkerDetail } from '@/frontend/pages/Dashboard/DigitalWorkers/types'
import type {
  ProcessDetailData,
  ProcessExecutionsPayload,
  LinkedRoutine,
  AvailableRoutine,
  ProcessMemory,
} from '@/frontend/features/ProcessDetail/types'

interface Props {
  page_title: string
  worker: DigitalWorkerDetail
  process: ProcessDetailData
  executions: ProcessExecutionsPayload
  linked_routines: LinkedRoutine[]
  upcoming_runs: LinkedRoutine[]
  available_routines: AvailableRoutine[]
  routines_error?: string | null
  memory: ProcessMemory
}

/**
 * Detalhe do processo (Iteração 3, Onda C) — a tela mais importante da virada
 * "gestão de trabalho": esse processo rodou em tal momento, gerou esse output
 * e está agendado pra tal dia. Vive na moldura do portal (WorkerPortalShell,
 * grupo Processos ativo) com um header próprio + grid 1.6fr/1fr: EXECUÇÕES
 * reais à esquerda, painéis (Rotinas associadas · Próximos agendamentos ·
 * Memória & skill) à direita. Honestidade de dados: tudo é real; o que não é
 * derivável é omitido (INVESTIGACAO-DADOS.md). Light e dark.
 */
export default function ProcessoDetail({
  page_title,
  worker,
  process,
  executions,
  linked_routines,
  upcoming_runs,
  available_routines,
  routines_error,
  memory,
}: Props) {
  return (
    <>
      <Head title={page_title} />
      <WorkerPortalShell worker={worker} section="processos">
        <div className="animate-fade-up space-y-6">
          <ProcessDetailHeader process={process} />

          <div className="grid items-start gap-5 lg:grid-cols-[1.6fr_1fr]">
            <ExecutionsPanel executions={executions} />

            <div className="space-y-3">
              <RoutinesSidePanel
                process={process}
                linkedRoutines={linked_routines}
                availableRoutines={available_routines}
                routinesError={routines_error}
              />
              <UpcomingRunsSidePanel runs={upcoming_runs} />
              <MemorySidePanel memory={memory} />
            </div>
          </div>
        </div>
      </WorkerPortalShell>
    </>
  )
}
